import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';
dayjs.extend(relativeTime);
dayjs.extend(duration);

/**
 * Returns a humanized string describing the difference between two dates
 * @param date1
 * @param date2
 */
export const getHumanizedDiff = (
  date1: string | number | Date | dayjs.Dayjs,
  date2: string | number | Date | dayjs.Dayjs,
): string => {
  var duration = dayjs(date1).diff(dayjs(date2), 'minutes');
  return dayjs.duration(duration, 'minutes').humanize();
};
